import { render, staticRenderFns } from "./SelectionAddressInput.vue?vue&type=template&id=be87ff26"
import script from "./SelectionAddressInput.vue?vue&type=script&lang=ts"
export * from "./SelectionAddressInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports